export class ForgotPasswrodFormModel {
  constructor(data = {}) {
    this.email = data?.email || "";
  }
}
